// extracted by mini-css-extract-plugin
export var container = "_2r-0";
export var disabled = "_2r-3";
export var enabled = "_2r-2";
export var statusLight = "_2r-1";